import React, { useState, useEffect } from "react";
import axios from "axios";
import "./css/SchedulePage.css";
import config from "../config"; // Импортируем API_URL

const SchedulePage = () => {
  const [schedule, setSchedule] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchSchedule = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        setError("Вы не авторизованы.");
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(`${config.API_URL}/schedule`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSchedule(response.data);
      } catch (err) {
        console.error("Ошибка загрузки расписания:", err);
        setError("Ошибка загрузки расписания.");
      } finally {
        setLoading(false);
      }
    };

    fetchSchedule();
  }, []);

  // Дни недели
  const weekdays = ["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"];

  // Группировка занятий по дням недели
  const groupedSchedule = weekdays.map((day, index) => {
    const lessons = schedule.filter((lesson) => lesson.weekday === index + 1);
    
    // Группируем по номеру пары (order)
    const groupedLessons = {};
    lessons.forEach((lesson) => {
      if (!groupedLessons[lesson.order]) {
        groupedLessons[lesson.order] = { numerator: null, denominator: null };
      }
      if (lesson.is_even_week) {
        groupedLessons[lesson.order].numerator = lesson;
      } else {
        groupedLessons[lesson.order].denominator = lesson;
      }
    });

    return { day, lessons: groupedLessons };
  });

  return (
    <div className="schedule-page">
      <h2 className="main-text-schedule">Расписание занятий</h2>

      {loading ? (
        <p>Загрузка расписания...</p>
      ) : error ? (
        <p className="error-text">{error}</p>
      ) : (
        <div className="schedule-table">
          {groupedSchedule.map(({ day, lessons }) => (
            <div key={day} className="schedule-day">
              <h3 className="second-text-schedule">{day}</h3>
              {Object.keys(lessons).length > 0 ? (
                <table>
                  <thead>
                    <tr>
                      <th>№</th>
                      <th>Предмет</th>
                      <th>Аудитория</th>
                      <th>Преподаватель</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.entries(lessons).map(([order, { numerator, denominator }]) => (
                      <tr key={order} className={numerator && denominator ? "split-row" : ""}>
                        <td>{order}</td>
                        <td>
                          {numerator && <div className="numerator">{numerator.subject}</div>}
                          {denominator && <div className="denominator">{denominator.subject}</div>}
                        </td>
                        <td>
                          {numerator && <div className="numerator">{numerator.classroom}</div>}
                          {denominator && <div className="denominator">{denominator.classroom}</div>}
                        </td>
                        <td>
                          {numerator && <div className="numerator">{numerator.teacher}</div>}
                          {denominator && <div className="denominator">{denominator.teacher}</div>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <p className="no-lessons">Нет занятий</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SchedulePage;
